<template>
  <el-form-item
    :label="label"
    class="date-time"
    :prop="prop"
    :rules="rules"
  >
    <el-date-picker
      v-model="date"
      type="datetime"
      :format="format"
      :value-format="format"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
    />
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    Validator
  ],
  props: {
    value: Date,
    label: String,
    prop: {
      type: String,
      default: 'Date'
    },
    placeholder: {
      type: String,
      default: 'yyyy/MM/dd HH:mm'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: 'yyyy/MM/dd HH:mm'
    }
  },
  data () {
    return {
    }
  },
  computed: {
    date: {
      get () {
        return this.value
      },
      set (date) {
        this.$emit('input', date)
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'change'))
          }
        }
        return rules
      }
    }
  },
  mounted () {
    const inner = this.$el.querySelector('.el-input__inner')
    inner.setAttribute('maxlength', '16')
  }
}
</script>

<style lang="scss">
</style>
